<template>
    <div class="content">
      <el-row class="bgW" v-if="userInfo.type != 3">
        <el-col :span="22">
          <!--检索条件-->
          <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
            <el-form-item label="店铺" v-if="!userInfo.shop_id">
              <el-select
                v-model="search.shopId"
                clearable
                remote
                filterable
                :remote-method="remoteMethod"
                placeholder="请输入店铺名称"
                class="w140"
              >
                <el-option
                  v-for="item in options.shopId"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </el-form-item>
            
            <!-- <el-form-item label="状态">
              <el-select v-model="search.status" clearable class="w140" placeholder="请选择统状态">
                <el-option
                  v-for="item in options.status"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item> -->
          </el-form>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        </el-col>
      </el-row>
      <div class="accountCon">
        <!-- <el-button
          v-if="!userInfo.shop_id"
          type="primary"
          :disabled="!idList.length"
          class="mb10"
          size="mini"
          @click="hint('导出选中列表', 'export')"
        >导出数据</el-button> -->
        <el-button type="primary"  class="mb10" size="mini" @click="goAdd"  v-if="is_show_allot">客户分配</el-button>
        <!--列表-->
        <el-row>
          <el-col :span="24">
            <el-table
              :data="list"
              size="small"
              border
              v-loading="loading"
              :cell-style="$style.cellStyle"
              :header-cell-style="$style.rowClass"
              @selection-change="handleSelectionChange"
            >
             
              <ElTableColumn label="门店" prop="shop_name" />
              <ElTableColumn label="转出员工姓名" prop="out_person_name"  />
              <ElTableColumn label="转入员工姓名" prop="in_person_name" />
              <ElTableColumn label="分配数量" prop="allot_count"  />
              <ElTableColumn label="操作人" prop="operator_name"  />
              <ElTableColumn label="操作时间" prop="create_time"  />
              <ElTableColumn label="操作" fixed="right" width="120">
                <template slot-scope="{ row }">
                  <span class="theme" @click="tapBtn('detail', row.id)">查 看</span>
                </template>
              </ElTableColumn>
            </el-table>
            <pagination
              class="page tc mt10"
              :total="page.total"
              :page.sync="page.page"
              :limit.sync="page.limit"
              @pagination="getList"
            />
          </el-col>
        </el-row>
      </div>
      <!-- 新增弹框 -->
    <!-- 顾客分配 -->
    <el-dialog title="客户分配" :visible.sync="addAllotPop" width="40%">
      <el-form
        :inline="true"
        ref="verifyDetail"
        size="mini"
        :model="verifyDetail"
        label-width="90px"
      >

      <el-form-item label="分配类型">
          <el-select
            v-model="verifyDetail.allot_type"
            placeholder="请选择"
            class="w220"
            @change="changeAllotType"
          >
            <el-option
              v-for="item in options.allot_type"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="转出护理师">
          <el-select
            v-model="verifyDetail.out_person_id"
            placeholder="请选择"
            class="w220"
            @change="changePerson"
          >
        
            <el-option
              v-for="item in options.out_person"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.customer_count }}</span>
            </el-option>



          </el-select>
        </el-form-item>

        <el-form-item label="转入护理师">
          <el-select
            v-model="verifyDetail.in_person_id"
            placeholder="请选择"
            class="w220"
          >
            <el-option
              v-for="item in options.in_person"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="分配数量" v-if="is_show_allot_all">
           <el-input-number v-model="verifyDetail.allot_count"  :min="0"  label="描述分配数量"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addAllotPop = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('verifyDetail')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog title="查看" :visible.sync="allotDetailsPop" width="45%">
       <el-button 
          size ="mini"
          v-for="(item, index) in allotCusotmerList" 
          :key="index"
          :type="item.type"  
          style="margin: 5px 5px; cursor: default;"
        >
          {{ item.customer_name }}
        </el-button>
    </el-dialog>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import pagination from "@/components/Pagination";
  import { getShopList } from "@/api/shop";
  import {
    staffList,
    readAdminPositionList,
    staffExport,
    getperson,getAllotList,addAllot,getOutInPersonList,getPersonCustomerList,getAllotCustomerList
  } from "@/api/staff";
// import { fa, tr } from "element-plus/es/locales.mjs";
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class Search {
    shopId = ""; // 店铺
    name = ""; // 员工名称
    phone = ""; // 员工电话
    positionId = ""; // 职位
    status = ""; // 状态
  }
  class TaskDetail {
    year = ""; // 年份
    moneth = ""; // 月份
  }
  class Options {
    constructor() {
      this.positionId = [];
      this.shopId = [];
      this.out_person = [];
      this.in_person = [];
      this.allot_type = [
        { id: 1, name: "全部分配" },
        { id: 2, name: "部分分配" },
      ];
    }
  }
  class VerifyDetail{
    allot_type = 1;
    out_person_id = '';
    in_person_id = '';
    allot_count = '';
  }
  export default {
    name: "OrderList",
    components: {
      pagination
    },
    data() {
      return {
        verifyDetail: new VerifyDetail(),
        search: new Search(), // 检索条件
        taskDetail: new TaskDetail(),
        options: new Options(), // 选项
        page: new Page(), // 分页
        list: [], // 数据展示 
        allotCusotmerList:[],
        idList: "",
        loading: false,
        scoreExport: false,
        addAllotPop:false,
        allotDetailsPop:false,
        is_show_allot:false,
        is_show_allot_all:false,
        time: ""
      };
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    mounted() {
      this.getOptions();
      this.getList();
    },
    methods: {
      changeAllotType(){
        this.is_show_allot_all = false;
        if( this.verifyDetail.allot_type == 2){
          this.is_show_allot_all = true;
        }else{
          this.is_show_allot_all = false;
        }
      },
      goAdd(){
        this.addAllotPop = true;
        this.verifyDetail = new VerifyDetail()
       
        getOutInPersonList().then(res => {
           this.addAllotPop = true;
            this.options.out_person = res.out_person;
            this.options.in_person = res.in_person;
        });
        
      },

      changePerson(){
        
          this.verifyDetail.allot_count = '';
          getPersonCustomerList({out_person_id:this.verifyDetail.out_person_id}).then(res => {
            console.log(res)
            this.verifyDetail.allot_count = res;
          })
      },
      // 获取选项
      getOptions() {
        readAdminPositionList().then(res => {
          this.options.positionId = res.list;
        });
      },
      remoteMethod(e) {
        getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
          this.options.shopId = res.list;
        });
      },
      // 获取列表
      getList(option) {
        this.loading = true;
        if (option === "search") this.page = new Page();
        getAllotList({ ...this.search, ...this.page }).then(res => {
          this.list = res.list;
          this.page.total = res.dataCount;
          this.is_show_allot = res.is_show_allot
          this.loading = false;
          
        });
      },
      // 选择时间
      changeTime(e) {
        var index = e.lastIndexOf("-");
        this.taskDetail.year = e.substring(0, index);
        this.taskDetail.moneth = e.substring(index + 1, e.length);
      },
      // 关闭弹窗
      closeTask() {
        this.taskDetail = new TaskDetail();
        this.time = "";
      },

   
      // 提交
      submitForm(formName) {
        // this.checking();
        this.$refs[formName].validate(valid => {
          if (valid) {
           this.hint("分配顾客", "add");
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      // 点击详情
      tapBtn(type, id) {
        switch (type) {
          case "detail":
            this.allotDetailsPop = true;
            getAllotCustomerList({logid:id}).then(res => {
              console.log(res)
              this.allotCusotmerList = res.list;
            })
          break;
        
        }
      },
      // 提示
      hint(text, type) {
        this.$confirm(`${text},是否确定？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
             if (type == "add") {
                this.confirm();
              } 
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      confirm() {
        addAllot({...this.verifyDetail}).then(res => {
          this.$message.success('分配成功');
          this.addAllotPop = false;
          this.getList();
        });
      },

      // 改变表格选中状态
      handleSelectionChange(val) {
        this.idList = val.map(i => {
          return i.id;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .bgW {
    background: #fff;
    border-radius: 3px;
    margin-bottom: 20px;
  }
  .el-form-item {
    margin: 5px 40px 3px 0;
  }
  .accountCon {
    background: #fff;
    padding: 10px 0px 80px;
  }
  .footerBtn {
    text-align: right;
  }
  </style>
  